/**
 * CR434: Single canonical merge helper.
 * Merges canonical_deal_json into the row, ensuring row.id always wins.
 * This prevents canonical JSON (which often has id=null) from clobbering the real id.
 */
export function mergeCanonicalDeal(row: any): Record<string, unknown> {
  const json =
    typeof row?.canonical_deal_json === "object" && row.canonical_deal_json
      ? (row.canonical_deal_json as Record<string, unknown>)
      : {};

  const resolvedId = row?.id ?? row?.deal_id ?? json?.id ?? null;

  return {
    ...json,
    ...row,
    id: resolvedId, // must be last so canonical can't clobber it
  };
}
